import React, { useEffect, useState, useMemo, useRef } from 'react';
import ReportTrackerButton from './ReportTrackerButton';
import SearchModal from './SearchModal';
import Swal from 'sweetalert2';
import { StudyBrowserViewOptions } from '@ohif/ui-next';

type User = {
  user_id: string;
  preferredName: string;
  username: string;
  designation: string;
  teamRole: string;
  UserSignature?: string;
};

const ModalitySelector = ({ selectedModalities, setSelectedModalities }) => {
  const [modalityDropdownVisible, setModalityDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  // Handle outside clicks
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setModalityDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      style={{ position: 'relative', marginRight: '16px' }}
      ref={dropdownRef}
    >
      <input
        type="text"
        readOnly
        placeholder="Select Modality"
        value={selectedModalities.length > 0 ? selectedModalities.join(', ') : 'Select Modality'}
        onClick={() => setModalityDropdownVisible(prev => !prev)}
        style={{
          cursor: 'pointer',
          width: '240px',
          height: '42px',
          padding: '10px 12px',
          borderRadius: '6px',
          border: '1px solid #555',
          fontSize: '14px',
          backgroundColor: '#2c2c2c',
          color: '#fff',
        }}
      />

      {modalityDropdownVisible && (
        <div
          style={{
            position: 'absolute',
            top: '50px',
            left: 0,
            backgroundColor: '#3a3b3d',
            border: '1px solid #555',
            borderRadius: '6px',
            padding: '12px',
            zIndex: 100,
            maxHeight: '300px',
            overflowY: 'auto',
            width: '240px',
          }}
        >
          <div style={{ marginBottom: '12px' }}>
            <button
              onClick={() => setSelectedModalities([])}
              style={{
                padding: '6px 12px',
                backgroundColor: '#4a4b4d',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
                width: '100%',
              }}
            >
              Clear All
            </button>
          </div>
          {['CT', 'MRI', 'DX', 'CR', 'Ultrasound'].map(option => (
            <label
              key={option}
              style={{
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                marginBottom: '10px',
                cursor: 'pointer',
                gap: '10px',
                padding: '4px 6px',
                borderRadius: '4px',
                backgroundColor: selectedModalities.includes(option) ? '#5a5b5d' : '#4a4b4d',
              }}
            >
              <input
                type="checkbox"
                checked={selectedModalities.includes(option)}
                onChange={e => {
                  const isChecked = e.target.checked;
                  setSelectedModalities(prev =>
                    isChecked ? [...prev, option] : prev.filter(m => m !== option)
                  );
                }}
                style={{ margin: 0 }}
              />
              <span style={{ fontSize: '14px' }}>{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const InstitutionSelector = ({
  selectedInstitutions,
  setSelectedInstitutions,
  institutionOptions,
}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      style={{ position: 'relative', marginRight: '16px' }}
      ref={dropdownRef}
    >
      <input
        type="text"
        readOnly
        placeholder="Select Institution"
        value={
          selectedInstitutions.length > 0 ? selectedInstitutions.join(', ') : 'All Institutions'
        }
        onClick={() => setDropdownVisible(prev => !prev)}
        style={{
          cursor: 'pointer',
          width: '240px',
          height: '42px',
          padding: '10px 12px',
          borderRadius: '6px',
          border: '1px solid #555',
          fontSize: '14px',
          backgroundColor: '#2c2c2c',
          color: '#fff',
        }}
      />

      {dropdownVisible && (
        <div
          style={{
            position: 'absolute',
            top: '50px',
            left: 0,
            backgroundColor: '#3a3b3d',
            border: '1px solid #555',
            borderRadius: '6px',
            padding: '12px',
            zIndex: 100,
            maxHeight: '300px',
            overflowY: 'auto',
            width: '240px',
          }}
        >
          <div style={{ marginBottom: '12px' }}>
            <button
              onClick={() => setSelectedInstitutions([])}
              style={{
                padding: '6px 12px',
                backgroundColor: '#4a4b4d',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '13px',
                width: '100%',
              }}
            >
              Clear All
            </button>
          </div>
          {institutionOptions.map(option => (
            <label
              key={option}
              style={{
                display: 'flex',
                alignItems: 'center',
                color: '#fff',
                marginBottom: '10px',
                cursor: 'pointer',
                gap: '10px',
                padding: '4px 6px',
                borderRadius: '4px',
                backgroundColor: selectedInstitutions.includes(option) ? '#5a5b5d' : '#4a4b4d',
              }}
            >
              <input
                type="checkbox"
                checked={selectedInstitutions.includes(option)}
                onChange={e => {
                  const isChecked = e.target.checked;
                  setSelectedInstitutions(prev =>
                    isChecked ? [...prev, option] : prev.filter(m => m !== option)
                  );
                }}
                style={{ margin: 0 }}
              />
              <span style={{ fontSize: '14px' }}>{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};
const SyncDicom = () => {
  fetch('https://studies.clarify-pacs.com/DICOMysqlSyncronizer.php')
    // fetch('http://38.242.140.57/pacs/DICOMysqlSyncronizer.php')
    .then(response => response.text())
    .then(data => console.log('DICOM Sync complete:', data))
    .catch(error => console.error('DICOM Sync error:', error));
};

const WorkList = () => {
  const [studies, setStudies] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const handleSearch = () => {
    setShowSearchModal(true);
  };
  const [teamRole, setTeamRole] = useState(null);

  const [user, setUser] = useState<{
    user_id: string;
    preferredName: string;
    username: string;
    designation: string;
    teamRole: string;
    UserSignature?: string;
  } | null>(null);

  const [modality, setModality] = useState('');
  const [studyDate, setStudyDate] = useState('');
  const [modalityDropdownVisible, setModalityDropdownVisible] = useState(false);
  const [selectedModality, setSelectedModality] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedModalities, setSelectedModalities] = useState<string[]>([]);
  const [selectedInstitutions, setSelectedInstitutions] = useState<string[]>([]);
  const dataPath = '';
  const [logoutLabel, setLogoutLabel] = useState('');
  const [showLoginButton, setShowLoginButton] = useState(false);
  const [showLogoutButton, setShowLogoutButton] = useState(true);
  const [showUsernameLabel, setShowUsernameLabel] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [selectedTeamDoc, setSelected] = React.useState('');
  const [open, setOpen] = React.useState(false);

  // Common styles
  const headerStyle = {
    height: '30px',
    padding: '1rem 0.1rem',
    borderRadius: '0px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#2c2d2e',
    margin: '0',
    color: '#e1e5e8',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    zIndex: '1000',
  };

  const buttonStyle = {
    height: '28px',
    backgroundColor: '#332f2f',
    color: '#fc2d39',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
    padding: '0.1rem 0.1rem',
    fontWeight: 'bold',
  };
  const inputStyle = {
    width: '150px',
    backgroundColor: '#3a3b3d',
    color: '#fff',
    border: '1px solid #555',
  };
  const tableStyle = {
    width: '100%',
    backgroundColor: '#2f2f31',
    color: '#d1c9c9',
    borderCollapse: 'collapse',
  };
  const cellStyle = {
    border: '1px solid rgb(149, 118, 106)', //table grid colour
    padding: '10px',
    backgroundColor: '#3d3d3c', // tables
    color: '#ede8e8',
  };

  const handleTrackerButtonClick = async studyInstanceUid => {
    try {
      const response = await fetch(
        `https://studies.clarify-pacs.com/pdfDataFetcher.php?studyInstanceUid=${studyInstanceUid}`,

        // `http://38.242.140.57/pacs/pdfDataFetcher.php?studyInstanceUid=${studyInstanceUid}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.ok) {
        const blob = await response.blob();
        const pdfUrl = URL.createObjectURL(blob);
        const width = 900;
        const height = 800;
        const left = 0;
        const top = 0;

        const newWindow = window.open(
          pdfUrl,
          '_blank',
          `width=${width},height=${height},top=${top},left=${left}`
        );
        newWindow.focus();
      } else {
        console.error('Failed to fetch PDF:', response.statusText);
      }
    } catch (error) {
      console.error('Error during fetch:', error);
    }
  };
  // Fetch authentication and study data, and page info useEffect(() => {
  useEffect(() => {
    const fetchData = async () => {
      try {
        const studiesRes = await fetch(
          `https://studies.clarify-pacs.com/stdfetch.php?page=${page}`,
          {
            credentials: 'include',
            headers: { Accept: 'application/json' },
          }
        );

        if (!studiesRes.ok) {
          return console.error('Studies fetch failed:', studiesRes.status);
        }

        const studiesData = await studiesRes.json();

        const sortedData = studiesData.data.sort((a, b) =>
          (b.Array?.StudyDate || '').localeCompare(a.Array?.StudyDate || '')
        );

        setStudies(sortedData);
        setTotalPages(studiesData.total_pages);
        console.log('Fetching page:', page);
      } catch (err) {
        console.error('Unexpected error during data fetch:', err);
      }
    };

    fetchData();
  }, [page]); // ✅ Correct useEffect block

  const handleLogout = async () => {
    try {
      // Show the label
      setLogoutLabel('Logged Out.');
      setShowLoginButton(true);
      setShowLogoutButton(false);
      setShowUsernameLabel(false);

      // Call the logout PHP script
      await fetch('https://studies.clarify-pacs.com/logout.php', {
        method: 'POST',
        credentials: 'include',
      });

      // Clear user state
      setUser(null);

      // Optional pause
      await new Promise(resolve => setTimeout(resolve, 300));

      // Redirect to login
      window.location.href = 'https://studies.clarify-pacs.com/index.php';
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  // Date formatting helper
  const formatDate = (rawDate: string) => {
    if (!rawDate || rawDate.length !== 8) return rawDate;
    const [year, month, day] = [
      rawDate.substring(0, 4),
      rawDate.substring(4, 6),
      rawDate.substring(6, 8),
    ];
    return `${day}/${month}/${year}`;
  };

  // Memoized filtered studies
  const filteredStudies = useMemo(() => {
    return studies.filter(study => {
      const searchText =
        `${study.PatientName} ${study.Array?.StudyDate} ${study.Array?.Modality} ${study.Array?.StudyDescription} ${study.InstitutionName}`.toLowerCase();
      const matchesSearch = searchText.includes(searchTerm.toLowerCase());
      const matchesModality =
        selectedModalities.length === 0 || selectedModalities.includes(study.Array?.Modality);
      const matchesInstitution =
        selectedInstitutions.length === 0 || selectedInstitutions.includes(study.InstitutionName);

      const studyDate = study.Array?.StudyDate || '';
      const startFilter = startDate ? startDate.replace(/-/g, '') : '';
      const endFilter = endDate ? endDate.replace(/-/g, '') : '';
      const matchesDate =
        (!startFilter || studyDate >= startFilter) && (!endFilter || studyDate <= endFilter);

      return matchesSearch && matchesModality && matchesDate && matchesInstitution;
    });
  }, [studies, searchTerm, selectedModalities, selectedInstitutions, startDate, endDate]);
  const institutionOptions = useMemo(() => {
    return Array.from(
      new Set(
        studies.map(study => study.InstitutionName).filter(name => name && name.trim() !== '')
      )
    ).sort();
  }, [studies]);
  // Table Header
  const [leadDialogOpen, setLeadDialogOpen] = useState(false);
  const [leadDialogStudyUID, setLeadDialogStudyUID] = useState(null);
  const [leadDialogStudy, setLeadDialogStudy] = useState(null); // holds full study object
  const [assignedRadiologist, setassignedRadiologist] = useState(null);

  useEffect(() => {
    fetch('https://studies.clarify-pacs.com/session.php', {
      credentials: 'include',
    })
      .then(res => res.json())
      .then(data => {
        if (data.user_id && data.username) {
          console.log('Session data before merge:', data); // ← log before merging

          // fetch teamRole using username from session
          fetch(`https://studies.clarify-pacs.com/fetchTeamRole.php?username=${data.username}`, {
            credentials: 'include',
          })
            .then(res => res.json())
            .then(roleData => {
              // insert teamRole into data object
              const mergedData = { ...data, teamRole: roleData.teamRole };

              // now save merged object as user
              setUser(mergedData);

              // also store separately if you still want it
              setTeamRole(roleData.teamRole);

              console.log('sesion Final Data :', mergedData);
            })
            .catch(err => console.error('Error fetching teamRole:', err));
        }
      })
      .catch(err => console.error('Error fetching session:', err));
  }, []);

  async function handleAssign(selectedTeamDoc) {
    if (!selectedTeamDoc) return;
    console.log('handleAssign called with:', selectedTeamDoc);
    console.log('studyUID:', leadDialogStudyUID);

    try {
      // First POST: assign radiologist
      const assignResponse = await fetch('https://studies.clarify-pacs.com/saveAssignedDoc.php', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          studyUID: leadDialogStudyUID,
          assignedRadiologist: selectedTeamDoc,
        }),
      });

      const assignData = await assignResponse.json();
      if (!assignResponse.ok) {
        throw new Error(assignData.error || 'Failed to save assignment');
      }

      // Second POST: save report status
      const statusResponse = await fetch('https://studies.clarify-pacs.com/saveAssignButton.php', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          studyUID: leadDialogStudyUID,
          reportTracker_button: 'Scheduled',
        }),
      });

      const statusData = await statusResponse.json();
      if (!statusResponse.ok) {
        throw new Error(statusData.error || 'Failed to save report status');
      }

      // Success alert after both complete
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Radiologist assigned.',
        timer: 2000,
        showConfirmButton: false,
        didOpen: () => {
          const container = document.querySelector('.swal2-container');
          if (container) container.style.zIndex = '999999';
          const popup = document.querySelector('.swal2-popup');
          if (popup) {
            popup.style.width = '400px';
            popup.style.height = '300px';
            popup.style.padding = '5px';
          }
        },
      });

      setOpen(false);
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  }

  const renderTableHeader = () => (
    <tr
      style={{ height: '60px', backgroundColor: '#3d3e40', color: '#d1c9c9', textAlign: 'center' }}
    >
      <th
        style={{
          fontSize: '20px',
          border: '1px solid rgb(128, 129, 132))',
          padding: '10px',
          color: '#f2f7f4',
          backgroundColor: '#3b3737', //  background for Status
        }}
      >
        Status
      </th>
      {[
        'Patient Name',
        'Age',
        'Sex',
        'Modality',
        'Series',
        'Description',
        'Date',
        'Institution',
      ].map((label, idx) => (
        <th
          key={idx}
          style={{
            fontSize: '20px',
            border: '1px solid rgb(146, 146, 154)',
            padding: '10px',
            color: '#f2f7f4', // colour of text of headers
            backgroundColor: '#3b3737', // table header background for all other header cells
            textAlign: 'left',
          }}
        >
          {label}
        </th>
      ))}
    </tr>
  );
  // handle row click

  // Table Row
  const renderTableRow = (study, index) => {
    const studyInstanceUid = study.StudyInstanceUID;

    return (
      <tr
        key={index}
        //   onClick={handleRowClick}
        /*
        onClick={() => {
          const defaultViewerUrl = `http://localhost:3000/Viewer?StudyInstanceUIDs=${study.StudyInstanceUID}`;
          window.open(defaultViewerUrl, '_blank'); // Opens in a new tab
        }} */

        /*
              //REGULAR
              onClick={() => {
                  const allowed = ['Radiologist', 'Radiographer'];
                  if (allowed.includes(user?.designation)) {
                    const defaultViewerUrl = `${dataPath ? '../../' : ''}Viewer${dataPath || ''}?StudyInstanceUIDs=${studyInstanceUid}`;
                    window.open(defaultViewerUrl, '_blank');
                  }
                  // else if (user) {
                  //alert('Access denied.');
                  // }
                }}

              */

        onClick={async () => {
          const studyInstanceUID = study.StudyInstanceUID;
          const archiveStatus = study.archiveStatus;

          const allowed = ['Radiologist', 'Radiographer'];
          const userDesignation = user?.designation;
          const preferredName = user?.preferredName;
          const teamRole = user?.teamRole;
          const username = user?.username;

          const defaultViewerUrl = `${dataPath ? '../../' : ''}Viewer${dataPath || ''}?StudyInstanceUIDs=${studyInstanceUID}`;
          // const defaultViewerUrl = `http://localhost:3000/Viewer?StudyInstanceUIDs=${encodeURIComponent(studyInstanceUID)}`;

          console.log('onClicked Data: STDuid', studyInstanceUID);
          console.log('onClicked Data archivestatus:', archiveStatus);
          console.log('onClicked Data preferredName:', preferredName);
          console.log('onClicked Data username:', username);
          console.log('onClicked Data Team Role:', teamRole);
          console.log('onClicked Data Designation:', userDesignation);

          // ✅ Step 1: Check if user is allowed
          if (!allowed.includes(userDesignation)) {
            console.warn('Access denied: user not allowed');
            return; // stop here
          }

          // ✅ Step 2: Check team role
          if (teamRole === 'LeadRadiologist') {
            setLeadDialogStudyUID(studyInstanceUID);
            setassignedRadiologist(selectedTeamDoc);
            setLeadDialogOpen(true);
            return; // stop here
          }

          // ✅ Step 3: If teamRole is NULL (no assigned team role)
          if (!teamRole) {
            try {
              const response = await fetch('https://studies.clarify-pacs.com/studySelector.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  studyInstanceUID,
                  archiveStatus,
                  preferredName,
                  username,
                  teamRole,
                  userDesignation,
                }),
              });

              const result = await response.json();
              console.log('teamRole-sent Response from studySelector.php:', result);

              if (result.success) {
                if (result.viewerUrl === 'defaultViewer') {
                  // Use frontend’s dynamic viewer
                  window.open(defaultViewerUrl, '_blank');
                } else {
                  // Use backend-provided viewer (archived)
                  window.open(result.viewerUrl, '_blank');
                }
              } else {
                console.error('Failed to open study:', result.message);
              }
            } catch (error) {
              console.error('Error contacting studySelector.php:', error);
            }
            return;
          }
        }}
        style={{ cursor: 'pointer' }}
      >
        <td style={{ ...cellStyle, padding: '1px', textAlign: 'center' }}>
          <button
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '98%',
              minWidth: '120px',
              height: '42px',
              border: 'none',
              borderRadius: '8px',
              padding: '0.01 0.1px',
              position: 'relative',
              cursor: 'pointer',
              color: '#fff',
              background: 'linear-gradient(to right,rgb(59, 59, 60),rgb(137, 132, 135))',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              overflow: 'hidden',
              transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            }}
            onClick={e => {
              e.stopPropagation();
              handleTrackerButtonClick(study.StudyInstanceUID);
            }}
            onMouseOver={e => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(97, 90, 90, 0.3)';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <span
              style={{
                position: 'absolute',
                inset: 0,
                borderRadius: '8px',
                backgroundColor: '#000',
                opacity: 0.2,
                zIndex: -1,
              }}
            />
            <span style={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
              <ReportTrackerButton studyInstanceUid={study.StudyInstanceUID} />
            </span>
          </button>
        </td>

        {[
          study.PatientName,
          study.Array?.PatientAge,
          study.Array?.PatientSex,
          study.Array?.Modality,
          study.Array?.BodyPartExamined,
          study.Array?.StudyDescription,
          formatDate(study.Array?.StudyDate),
          study.InstitutionName,
        ].map((cell, i) => (
          <td
            key={i}
            style={cellStyle}
          >
            {cell}
          </td>
        ))}
      </tr>
    );
  };

  return (
    <div
      className="container-fluid text-light min-vh-100"
      style={{
        border: '1px solid #382d2d', // or any other color you want
        backgroundColor: '#1f1f1f', // optional: to override default bootstrap bg
      }}
    >
      <div
        className="row"
        style={{
          border: '1px solid #382d2d', // or any other color you want
          backgroundColor: '#1f1f1f', // optional: to override default bootstrap bg
        }}
      >
        {/* HeaderSesions */}
        <div
          className="firstDiv col-12 mb-3"
          style={headerStyle}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            {user && user.preferredName ? (
              <span
                style={{
                  color: '#23db0b',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  padding: '16px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '12px',
                }}
              >
                {showUsernameLabel && user.preferredName}
                {showLogoutButton && (
                  <button
                    onClick={handleLogout}
                    style={{
                      height: '22px',
                      padding: '0 8px',
                      backgroundColor: '#de9797',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '12px',
                    }}
                    onMouseEnter={e => (e.target.style.backgroundColor = '#a84545')}
                    onMouseLeave={e => (e.target.style.backgroundColor = '#de9797')}
                  >
                    Logout
                  </button>
                )}
                {showLoginButton && (
                  <button
                    onClick={() =>
                      (window.location.href = 'https://studies.clarify-pacs.com/index.php')
                    }
                    style={{
                      marginLeft: '8px',
                      padding: '6px 12px',
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px',
                    }}
                    onMouseEnter={e => (e.target.style.backgroundColor = '#3e8e41')}
                    onMouseLeave={e => (e.target.style.backgroundColor = '#4CAF50')}
                  >
                    Login
                  </button>
                )}
                {logoutLabel && (
                  <span style={{ color: '#FF0000', marginLeft: '8px' }}>{logoutLabel}</span>
                )}{' '}
              </span>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span
                  style={{
                    color: '#db0909', // Dark Red
                    fontWeight: 'bold',
                    fontSize: '14px',
                    paddingLeft: '16px', // Add left padding here
                  }}
                >
                  Logged Out
                </span>
                <a
                  href="https://studies.clarify-pacs.com/index.php"
                  style={{
                    padding: '6px 12px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    textDecoration: 'none',
                    display: 'inline-block',
                  }}
                  onMouseEnter={e => (e.target.style.backgroundColor = '#3e8e41')}
                  onMouseLeave={e => (e.target.style.backgroundColor = '#4CAF50')}
                >
                  Login
                </a>
              </div>
            )}
          </div>
        </div>

        {/* Table Section */}
        <div
          className="col-12"
          style={{
            backgroundColor: '#2a2b2d',
            padding: '0.01 rem 0.01 rem',
            borderRadius: '8px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
          }}
        >
          {/* Table */}
          <div
            className="table-responsive"
            style={{
              backgroundColor: '#171616',
              width: '99.5%',
              margin: '0 auto',
            }}
          >
            <table
              className="table-hover table align-middle"
              style={{
                ...tableStyle,
                backgroundColor: 'transparent', // Let the div's background show through
                width: '99%',
                margin: '0 auto',
              }}
            >
              <thead>
                {/* Upper row with filter/search inputs - Now with black background */}
                <tr style={{ backgroundColor: '#171a18' }}>
                  <th
                    colSpan={9}
                    style={{ backgroundColor: '#171a18', padding: '1px 0' }}
                  >
                    {' '}
                    {/* the outer container */}
                    <div
                      className="mb-3"
                      style={{ backgroundColor: '#171a18' }}
                    >
                      <div
                        style={{
                          //inner container green
                          display: 'flex',
                          gap: '10px',
                          alignItems: 'center',
                          flexWrap: 'nowrap',
                          backgroundColor: '#171a18',
                          padding: '4px',
                          borderRadius: '4px',
                        }}
                      >
                        {/* Search input */}
                        <input
                          type="text"
                          placeholder="Filter List..."
                          value={searchTerm}
                          onChange={e => setSearchTerm(e.target.value)}
                          style={{
                            backgroundColor: '#171a18',
                            color: '#fff',
                            border: '1px solid #333',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            minWidth: '200px',
                          }}
                        />
                        <>
                          <button
                            onClick={handleSearch}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#fff',
                              cursor: 'pointer',
                              gap: '10px',
                              padding: '8px 16px',
                              border: 'none',
                              borderRadius: '4px',
                              backgroundColor: '#314632ff',
                              transition: 'background-color 0.2s ease',
                              fontWeight: '500',
                              width: '120px', // adjust as needed
                              height: '40px', // adjust as needed
                            }}
                            onMouseOver={e => (e.currentTarget.style.backgroundColor = '#3a7a3b')}
                            onMouseOut={e => (e.currentTarget.style.backgroundColor = '#2c5f2d')}
                            onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.98)')}
                            onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
                          >
                            Querry DB
                          </button>

                          {showSearchModal && (
                            <SearchModal
                              user={user}
                              onClose={() => setShowSearchModal(false)}
                            />
                          )}
                        </>

                        {/* Modality Selector */}
                        <div style={{ position: 'relative', marginRight: '16px' }}>
                          <ModalitySelector
                            selectedModalities={selectedModalities}
                            setSelectedModalities={setSelectedModalities}
                            // Add dark theme props if component supports them
                            className="dark-selector"
                          />
                        </div>

                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            flexWrap: 'nowrap',
                            backgroundColor: '#171a18',
                          }}
                        >
                          {/* Start Date */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <label style={{ color: '#ccc', whiteSpace: 'nowrap' }}>
                              Start From:
                            </label>
                            <input
                              type="date"
                              value={startDate}
                              onChange={e => setStartDate(e.target.value)}
                              style={{
                                backgroundColor: '#171a18',
                                color: '#fff',
                                border: '1px solid #333',
                                padding: '8px',
                                borderRadius: '4px',
                              }}
                            />
                          </div>

                          {/* End Date */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <label style={{ color: '#ccc', whiteSpace: 'nowrap' }}>End At:</label>
                            <input
                              type="date"
                              value={endDate}
                              onChange={e => setEndDate(e.target.value)}
                              style={{
                                backgroundColor: '#171a18',
                                color: '#fff',
                                border: '1px solid #333',
                                padding: '8px',
                                borderRadius: '4px',
                              }}
                            />
                          </div>

                          {/* Institution Selector */}
                          <InstitutionSelector
                            selectedInstitutions={selectedInstitutions}
                            setSelectedInstitutions={setSelectedInstitutions}
                            institutionOptions={institutionOptions}
                            // Add dark theme props if component supports them
                            className="dark-selector"
                          />

                          {/* Sync Button */}
                          <button
                            onClick={SyncDicom}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#fff',
                              cursor: 'pointer',
                              gap: '10px',
                              padding: '8px 16px',
                              border: 'none',
                              borderRadius: '4px',
                              backgroundColor: '#2f492fff',
                              transition: 'background-color 0.2s ease',
                              fontWeight: '500',
                              width: '150px', // adjust as needed
                              height: '40px', // adjust as needed
                            }}
                            onMouseOver={e => (e.currentTarget.style.backgroundColor = '#3a7a3b')}
                            onMouseOut={e => (e.currentTarget.style.backgroundColor = '#2c5f2d')}
                            onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.98)')}
                            onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
                          >
                            Sync DICOM
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>

                {/* Actual column headers below */}
                {renderTableHeader()}
              </thead>

              <tbody>
                {filteredStudies.length === 0 ? (
                  <tr>
                    <td
                      colSpan="8"
                      className="text-muted py-3 text-center"
                      style={{ border: '1px solid #c1d90f', padding: '10px' }}
                    >
                      No studies to display. Login first and retry ...
                    </td>
                  </tr>
                ) : (
                  filteredStudies.map(renderTableRow)
                )}
              </tbody>
            </table>
            <div className="d-flex justify-content-between align-items-center my-3 px-3">
              <button
                onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                disabled={page === 1}
                style={{
                  backgroundColor: '#444',
                  color: '#fff',
                  border: '1px solid #888',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  cursor: page === 1 ? 'not-allowed' : 'pointer',
                }}
              >
                ← Previous
              </button>

              <span style={{ color: '#ccc' }}>
                <span>
                  Page <strong>{isNaN(page) ? '1' : page}</strong> of{' '}
                  {isNaN(totalPages) ? '1' : totalPages}
                </span>
              </span>

              <button
                onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                disabled={page === totalPages}
                style={{
                  backgroundColor: '#444',
                  color: '#fff',
                  border: '1px solid #888',
                  padding: '6px 12px',
                  borderRadius: '4px',
                  cursor: page === totalPages ? 'not-allowed' : 'pointer',
                }}
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      </div>
      {leadDialogOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '8px',
              padding: '20px',
              maxWidth: '300px',
              width: '100%',
              textAlign: 'center',
            }}
          >
            <h3>Choose Action</h3>
            <button
              style={{
                display: 'block',
                width: '100%',
                padding: '10px',
                marginTop: '10px',
                backgroundColor: '#486149ff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={async () => {
                const studyInstanceUID = leadDialogStudyUID;

                // ✅ Find the study from state
                const study = studies.find(s => s.StudyInstanceUID === studyInstanceUID);
                const archiveStatus = study?.archiveStatus || null;

                // ✅ Build frontend default viewer URL (for non-archived)
                // const defaultViewerUrl = `http://localhost:3000/Viewer?StudyInstanceUIDs=${encodeURIComponent(studyInstanceUID)}`;
                const defaultViewerUrl = `${dataPath ? '../../' : ''}Viewer${dataPath || ''}?StudyInstanceUIDs=${studyInstanceUID}`;

                // ✅ Get user info
                const preferredName = user?.preferredName;
                const username = user?.username;
                const teamRole = user?.teamRole;
                const userDesignation = user?.designation;

                console.log('ViewStudyButton → study:', study);
                console.log('ViewStudyButton → archiveStatus:', archiveStatus);
                console.log('ViewStudyButton → user:', {
                  preferredName,
                  username,
                  teamRole,
                  userDesignation,
                });

                try {
                  // ✅ Send data to backend
                  const response = await fetch(
                    'https://studies.clarify-pacs.com/studySelector.php',
                    {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        studyInstanceUID,
                        archiveStatus,
                        preferredName,
                        username,
                        teamRole,
                        userDesignation,
                      }),
                    }
                  );

                  const result = await response.json();
                  console.log(
                    'LeadRadiologist-Buttoned-Triggered → Response from studySelector.php:',
                    result
                  );

                  // ✅ Decide which viewer to open
                  if (result.success) {
                    if (result.viewerUrl === 'defaultViewer') {
                      // open frontend’s local viewer
                      window.open(defaultViewerUrl, '_blank');
                    } else {
                      // open remote viewer provided by PHP
                      window.open(result.viewerUrl, '_blank');
                    }
                  } else {
                    console.error('Failed to open study:', result.message);
                  }
                } catch (err) {
                  console.error('Error calling studySelector.php:', err);
                }
              }}
            >
              View Study
            </button>

            <AssignRadiologistDropdown
              studyUID={leadDialogStudyUID}
              onAssign={handleAssign}
              username={user.username}
            />

            <button
              style={{
                display: 'block',
                width: '100%',
                padding: '10px',
                marginTop: '10px',
                backgroundColor: '#ccc',
                color: '#000',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
              onClick={() => setLeadDialogOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );

  function AssignRadiologistDropdown({
    studyUID,
    onAssign,
    username,
  }: {
    studyUID: any;
    onAssign: any;
    username: string;
  }) {
    console.log(
      'AssignRadiologistDropdown mounted with studyUID:',
      studyUID,
      'username:',
      username
    );

    console.log('username used for fetch:', username);
    const [open, setOpen] = React.useState(false);
    const [selected, setSelected] = React.useState('');
    const [doctors, setDoctors] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [assignedTo, setAssignedTo] = useState('None');

    React.useEffect(() => {
      if (!open || !username) return; // only fetch if dropdown is open and username is set

      setLoading(true);
      setError('');
      setDoctors([]);
      setSelected('');

      fetch(
        `https://studies.clarify-pacs.com/fetchTeam.php?username=${encodeURIComponent(username)}`,
        {
          credentials: 'include',
        }
      )
        .then(res => res.text())
        .then(text => {
          console.log('Raw response:', text);
          try {
            const data = JSON.parse(text);

            if (data.error) {
              setError(data.error);
              setDoctors([]);
            } else if (Array.isArray(data.teamMembers)) {
              setDoctors(data.teamMembers);
            } else {
              setDoctors([]);
            }
          } catch (e) {
            console.error('JSON parse error:', e);
            setError('Invalid response from server');
            setDoctors([]);
          }
        })
        .catch(err => {
          console.error('Fetch error:', err);
          setError('Failed to fetch team members');
          setDoctors([]);
        })
        .finally(() => setLoading(false));
    }, [open, username]);

    useEffect(() => {
      if (!studyUID) return;

      console.log('Initializing report for studyUID:', studyUID);

      fetch('https://studies.clarify-pacs.com/initialize_report.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          leadDialogStudyUID: studyUID,
          patientName: '', // replace if you have actual patient name
        }),
      })
        .then(response => response.json())
        .then(data => {
          console.log('Report initialized:', data);
        })
        .catch(error => {
          console.error('Error initializing report:', error);
        });
    }, [studyUID]);

    useEffect(() => {
      if (!studyUID) return;

      console.log('studyUID sent:', studyUID);

      fetch(
        `https://studies.clarify-pacs.com/fetchWhoAssigned.php?studyUID=${encodeURIComponent(studyUID)}`,
        {
          credentials: 'include',
        }
      )
        .then(async res => {
          const text = await res.text();
          console.log('Raw response text:', text);
          return JSON.parse(text);
        })
        .then(data => {
          console.log('fetchWhoAssigned data:', data);
          if (data?.assigned_to) {
            setAssignedTo(data.assigned_to);
          } else {
            setAssignedTo('None');
          }
        })
        .catch(err => {
          console.error('Fetch error in fetchWhoAssigned:', err);
          setAssignedTo('Error');
        });
    }, [studyUID]);

    return (
      <div style={{ marginTop: '10px', textAlign: 'left' }}>
        <button
          style={{
            display: 'block',
            width: '100%',
            padding: '10px',
            backgroundColor: '#4e4e4fff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
          onClick={() => setOpen(s => !s)}
          aria-expanded={open}
        >
          Assign Radiologist
        </button>
        <div style={{ marginBottom: '8px', fontWeight: 'bold', color: 'black' }}>
          Assigned to: <span style={{ color: 'black', fontWeight: 'normal' }}>{assignedTo}</span>
        </div>

        {open && (
          <div
            style={{
              marginTop: '10px',
              border: '1px solid #ccc',
              borderRadius: '6px',
              padding: '10px',
              background: '#e5d9d9ff',
              color: '#000000',
              zIndex: 10000,
            }}
          >
            {loading && <div>Loading doctors...</div>}
            {error && <div style={{ color: 'red' }}>{error}</div>}
            {!loading && !error && doctors.length === 0 && <div>No Radiologists in Your Team</div>}

            {!loading &&
              !error &&
              doctors.map(doc => (
                <label
                  key={doc}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '6px',
                    cursor: 'pointer',
                    padding: '4px 6px',
                    borderRadius: '4px',
                  }}
                  onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                  onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                >
                  <input
                    type="radio"
                    name={`radiologist-${studyUID}`}
                    value={doc}
                    checked={selected === doc}
                    onChange={() => setSelected(doc)}
                    style={{
                      marginRight: '10px',
                      transform: 'scale(1.5)',
                      accentColor: '#007BFF',
                      cursor: 'pointer',
                    }}
                  />
                  <span style={{ fontSize: '16px' }}>{doc}</span>
                </label>
              ))}

            <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
              <button
                onClick={() => {
                  if (!selected) return;

                  // Existing assignment logic
                  onAssign(selected);
                  setOpen(false);
                }}
                disabled={!selected}
                style={{
                  padding: '6px 10px',
                  borderRadius: '4px',
                  border: 'none',
                  cursor: selected ? 'pointer' : 'not-allowed',
                  backgroundColor: selected ? '#28a745' : '#ddd',
                  color: selected ? '#fff' : '#666',
                }}
              >
                Assign
              </button>

              <button
                onClick={() => setOpen(false)}
                style={{
                  padding: '6px 10px',
                  borderRadius: '4px',
                  border: '1px solid #888',
                  background: '#fff',
                  color: '#000',
                  cursor: 'pointer',
                }}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
};

export default WorkList;
